export function mousePosition(e) {
    e.stopPropagation();

    let posx = 0;
    let posy = 0;

    let yScroll = e.target.scrollTop || document.documentElement.scrollTop;

    if (e.pageX || e.pageY) {
        let bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

        posx = e.pageX - e.target.getBoundingClientRect().left - document.body.scrollLeft;
        posy = e.pageY - e.target.getBoundingClientRect().top - bodyScrollTop;
    } else if (e.clientX || e.clientY) {
        posx = e.clientX - e.target.getBoundingClientRect().left;
        posy = e.clientY - e.target.getBoundingClientRect().top;
    }

    return {
        x: posx,
        y: posy
    }
}

export function elementYPosition($el) {
    let posy = 0;

    posy += ($el.offsetTop - $el.scrollTop + $el.clientTop);

    return { y: posy };
}

export function shiftText(e) {
    let el = e.target;
    let positionObj = mousePosition(e);
    let x = positionObj.x;
    let y = positionObj.y;
    let elHeight = el.clientHeight;
    let elWidth = el.clientWidth;
    let innerEl = e.target.children["0"].children["0"].children["0"];

    let xPercentage = (x / elWidth) * 100;
    let yPercentage = (y / elHeight) * 100;

    /* Set the range of motion (range to -range (n to -n)) */
    let range = 14;

    let shiftX = ((range / 100) * xPercentage) - (range / 2);
    let shiftY = ((range / 100) * yPercentage) - (range / 2);

    if (e.type === 'mouseleave') {
      innerEl.style.transform = 'translate(0px, 0px) translateZ(0)'
    } else {
      innerEl.style.transform = 'translate(' + shiftX + 'px, ' + shiftY + 'px) translateZ(0)';
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/_events.js